import { filterParams } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

const PARAMS_KEYS_LIST = [
  'deviceFlagbinNeedPad'
]
const DEFAULT_DEVICE_FLAGBIN_NEED_PAD_VALUE = null

export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  console.warn(contractData)
  let revertted = {}
  if (contractData) {
    revertted = pick(contractData, PARAMS_KEYS_LIST)
    revertted.deviceFlagbinNeedPad = revertted.deviceFlagbinNeedPad < 0 ? DEFAULT_DEVICE_FLAGBIN_NEED_PAD_VALUE : revertted.deviceFlagbinNeedPad
    return revertted
  }
  revertted = {
    deviceFlagbinNeedPad: DEFAULT_DEVICE_FLAGBIN_NEED_PAD_VALUE // 启动费金额 默认值为0
  }
  return revertted
}

export function submitFormat (contractGlobal) {
    return {
      params: JSON.stringify({
        queryId: this.$route.params.id,
        source: 'contractor',
        contractGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
